import { get, post, upload, del, put } from '@api/request';

export const fetchDocuments = async (
  { litigationService },
  authenticationToken,
  { arbitrationID },
) => {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/documents`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function uploadDocument(
  { litigationService },
  authenticationToken,
  { payload },
) {
  const url = `${litigationService}/litigation/arbitration/uploaddocument`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function insertDocument(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/documents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteDocument(
  { litigationService },
  authenticationToken,
  { arbitrationDocumentID },
) {
  const url = `${litigationService}/litigation/arbitration/documents/${arbitrationDocumentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchDocumentsEvidence = async (
  { litigationService },
  authenticationToken,
  { arbitrationID },
) => {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const editDocumentsEvidence = async (
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) => {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function uploadDocumentEvidence(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function deleteDocumentEvidence(
  { litigationService },
  authenticationToken,
  { arbitrationID, s3ID },
) {
  const url = `${litigationService}/litigation/arbitration/${arbitrationID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
}
